









































































































































































































































import Vue from 'vue'
import SampleSound from '@/components/SampleSound.vue'
import Trivia from '@/components/Trivia.vue'
import PageTopButton from '@/components/howto/PageTopButton.vue'
import LetsStart from '@/components/howto/LetsStart.vue'
import ComposeButton from '@/components/howto/ComposeButton.vue'

interface State {
  isPlayingTrivia: boolean; // トリビア表示中
}

export default Vue.extend({
  name: 'Steps',

  components: {
    'sample-sound': SampleSound,
    trivia: Trivia,
    'page-top-button': PageTopButton,
    'lets-start': LetsStart,
    'compose-button': ComposeButton,
  },

  data (): State {
    return {
      isPlayingTrivia: false,
    }
  },

  mounted () {
    window.scrollTo(0, 0)
  },

  methods: {
    /**
     * 豆知識を閉じる
     */
    dismissTrivia () {
      console.log('dismissTrivia')
      this.isPlayingTrivia = false
    },
  },
})
